import React from "react";
import { Button, Steps } from "antd";
import ReactGA from "react-ga4";
import { useNavigate } from "react-router-dom";
import PageLoader from "../common/loader/pageLoader";
import SkincareGuide from "../../containers/skincareGuide";
interface WaitingComponentInterface {
  fetchProfile?: any;
  handleLogout?: any;
  loading?: boolean;
  handleLogin?: any;
  userData?: any;
}

const WaitingComponent: React.FC<WaitingComponentInterface> = (props) => {
  const { loading, handleLogout, userData } = props;
  const navigate = useNavigate();

  const firstName = userData?.user_information?.first_name;

  const getCurrentStep: any = () => {
    let currentStep = 0;

    // if (userData?.lucky_draw_status === "claimed") {
    //   return (currentStep = 2); // Return null in this case
    // }

    switch (userData?.survey_status) {
      case "draft":
        currentStep = 0;
        break;

      case "paid":
        currentStep = 2;
        break;

      case "answered":
        if (userData?.lucky_draw_status === "claimed") {
          currentStep = 2;
        } else {
          currentStep = 1;
        }
        break;

      case "responded":
        currentStep = 3;
        break;

      default:
        currentStep = 1;
    }

    return currentStep;
  };

  const getContinueButton = (upcomingStatus?: string) => {
    switch (userData?.survey_status) {
      case "draft":
        return (
          <>
            <Button
              size="small"
              type="primary"
              className="processing-btn stepper-btn"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Revise Skincare Timeline CTA Button Click`,
                  label: "Go to Payment",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
                navigate(`/product-opinion?id=${userData?.active_survey_id}`);
              }}
            >
              <span>Continue</span>
            </Button>
          </>
        );

      case "paid":
        return (
          <>
            <Button
              size="small"
              type="primary"
              className="stepper-btn processing-btn"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Revise Skincare Timeline CTA Button Click`,
                  label: "Go to quiz",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
                navigate("/store");
              }}
            >
              <span>Continue</span>
            </Button>
          </>
        );
      case "answered":
        if (userData?.lucky_draw_status === "claimed") {
          return <></>;
        }
        return (
          <>
            <Button
              size="small"
              type="primary"
              className="stepper-btn processing-btn"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Revise Skincare Timeline CTA Button Click`,
                  label: "Go to quiz",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
                navigate(`/product-opinion?id=${userData?.active_survey_id}`);
              }}
            >
              <span>Proceed to Pay</span>
            </Button>
          </>
        );

      default:
        return <></>;
    }
  };

  return loading ? (
    <PageLoader />
  ) : (
    <>
      <div className="waiting-page">
        <h1>Thank you {firstName}!</h1>
        <div className="content w-100">
          <div className="progress">
            <Steps
              className="progress__steps"
              size="small"
              current={getCurrentStep()}
              labelPlacement="vertical"
              responsive
              items={[
                {
                  title: `Payment ${
                    userData?.lucky_draw_status === "claimed" ? "Waived" : ""
                  }`,
                  description:
                    userData?.lucky_draw_status === "claimed"
                      ? "(Lucky Draw Winner)"
                      : userData?.survey_status === "answered"
                      ? getContinueButton("toAnswer")
                      : null,
                },
                {
                  title: "Skin Quiz Answered",
                },
                {
                  title: "Building Your Space",
                },
                {
                  title: "Get Email in Two Business Days or Less",
                },
              ]}
            />
          </div>
          {/* <h3>
            We will handcraft your personal skincare space and email you in 2
            business days or less.{" "}
          </h3> */}
          <div className="waiting-page__buttons">
            <Button
              className="btn-primary logout"
              type="dashed"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
      <SkincareGuide />
    </>
  );
};

export default WaitingComponent;
